module.exports = __webpack_public_path__ + "static/media/dark_mode_pk_logo.f8d4355b.svg";